import { render } from "./CajasList.vue?vue&type=template&id=3f88b390&scoped=true"
import script from "./CajasList.vue?vue&type=script&lang=js"
export * from "./CajasList.vue?vue&type=script&lang=js"

import "./CajasList.vue?vue&type=style&index=0&id=3f88b390&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f88b390"]])

export default __exports__